<ul class="sensitive-data flex" *transloco="let t">
  @if (selectedAccountGroup(); as selectedAccountGroup) {
    <div class="flex items-center">
      <account-group-selector
        [selectedAccountGroupId]="selectedAccountGroup.id"
        (selectAccountGroup)="selectGroup($event)"
      ></account-group-selector>

      @if (selectedMarketplacesMap().size > 0) {
        <div class="row mx-2" #marketplacesDiv>
          <ISelect
            class="min-w-0"
            [options]="marketplaceOptions()"
            [selectedValue]="selectedMarketplace()"
            (selectedOptionChange)="selectMarketplace($event)"
            [searchAttributes]="['label', 'name']"
            popperWidth="250px"
            [searchable]="true"
          >
            <ng-template #optionSlot #labelSlot let-v>
              <div class="flex items-center truncate text-sm text-gray-600">
                <marketplace-flag [marketplace]="v.value" />
                <span class="ml-2 font-medium">{{ v.label }} - {{ v.name }}</span>
              </div>
            </ng-template>
          </ISelect>
        </div>
      }
      @if (scope === "dashboard" && isReadOnly) {
        <span
          [className]="ICON_WARNING_TRIANGLE + ' text-orange-500 text-lg'"
          matTooltip="{{ t('account-selector.read_only_mode') }}"
        ></span>
      }
    </div>
  }
</ul>
